import { inject } from 'vue'
import { FlagsmithKey, type FeatureFlagKey } from '@/plugins/flagsmith'
import { type IFlagsmith } from 'flagsmith'

export const useFeatureFlags = () => {
  const flagsmith = inject<IFlagsmith<FeatureFlagKey>>(FlagsmithKey)

  if (!flagsmith) {
    throw new Error('useFeatureFlags must be called within a component that has access to the Flagsmith plugin')
  }

  return flagsmith
}
